import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { ClientStoreService } from '../../services/client-store.service';
import { blank, data_is_true, data_nullify, OptionalValue, spf } from '../utils/common';

@Injectable({
  providedIn: 'root',
})
export class DataStateStore {
  constructor(
    private readonly _storage: LocalStorageService,
    private readonly _client: ClientStoreService,
  ) {}

  update(key: FieldmagicDataStoreKey, state: FieldmagicStorableState): void {
    if (blank(this._client.getActiveClient())) {
      return;
    }

    key = this._makePerClientStoreKey(key);

    this._storage.setJsonItem(key, state);
  }

  retrieve(key: FieldmagicDataStoreKey): OptionalValue<FieldmagicStorableState> {
    if (blank(this._client.getActiveClient())) {
      return null;
    }

    key = this._makePerClientStoreKey(key);

    return data_nullify(this._storage.getJsonItem(key));
  }

  has(key: FieldmagicDataStoreKey): boolean {
    if (blank(this._client.getActiveClient())) {
      return false;
    }

    key = this._makePerClientStoreKey(key);

    return data_is_true(this._storage.hasItem(key));
  }

  destroy(key: FieldmagicDataStoreKey): void {
    if (blank(this._client.getActiveClient())) {
      return;
    }

    key = this._makePerClientStoreKey(key);

    this._storage.removeItem(key);
  }

  private _makePerClientStoreKey(prefix: string): string {
    const client = this._client.getActiveClient();

    return spf('%s:%s', {
      args: [prefix, client.client_id],
    });
  }
}

export type FieldmagicDataStoreKey = string;
export type FieldmagicStorableState = Record<string, any>;
